/**
 * Auditability (CU-86d345rgy): tell the API that the phone-verification requirement was
 * surfaced to the customer on the customer-details submit — fired BEFORE the confirm dialog,
 * so it captures customers who bail immediately and leave the order in DRAFT (no PATCH, no
 * code issued). Best-effort, idempotent server-side upsert — it never throws, so it can't
 * block or delay the submit / confirm dialog.
 */
export interface PromptShownHttp {
    post(url: string): Promise<unknown>;
}

export async function recordPhoneVerificationPromptShown(
    http: PromptShownHttp,
    orderId: number | string | null,
): Promise<boolean> {
    if (!orderId) {
        return false;
    }

    try {
        await http.post(`/customers/book/orders/${orderId}/phone/prompt-shown`);

        return true;
    } catch {
        // Telemetry only — swallow failures (a later submit attempt may retry).
        return false;
    }
}
